// Studio Workspace Inc 1 — /creator/studio: the studio hub dashboard in the
// creator AppShell. Shared component; see features/live/StudioDashboard.
import { createFileRoute } from '@tanstack/react-router';

import { StudioDashboard } from '@/features/live/StudioDashboard';

export const Route = createFileRoute('/creator/studio')({
  component: StudioDashboard,
});
